import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessFlowService {
  private http = inject(HttpClient);
  private url = Global.url;

  // Obtiene los procesos con sus flujos BPM completos
  getProcessesWithFlows(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}V1/process-ref/flows?usesBpm=true`);
  }

  // Obtiene catalogo ligero de procesos sin flujos
  getCatalog(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}V1/process-ref`);
  }

  // Guarda en lote la configuracion del flujo BPM por UUID o ID
  saveStatusFlowBulk(
    processKey: string | number,
    flows: any[],
    options?: { applyToOpen?: boolean }
  ): Observable<any> {
    const isUuid = typeof processKey === 'string' && /^[0-9a-f-]{36}$/i.test(processKey);
    const body: any = isUuid ? { processUuid: processKey, flows } : { processId: processKey, flows };
    if (options?.applyToOpen) body.applyToOpen = true;
    return this.http.post<any>(`${this.url}V1/process-status-flow/bulk`, body);
  }
}
